import React from "react";

export default function SQL_Aliases() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_Aliases</h1>
      <p>This is the SQL_Aliases component generated from the SQL JSON.</p>
    </div>
  );
}
